// i18n area 'storage' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.bg-BG.meta.json.
import type { enUS } from './storage'

export const bgBG: typeof enUS = {
  storage: {
    pools: {
      title: 'Хранилища',
      createTitle: 'Създай хранилище',
      path: 'Път',
      pathHint: 'Абсолютен път под позволен корен (по подразбиране /var/lib/tvirt/pools/)',
      shared: 'Споделено хранилище',
      sharedChip: 'споделено',
      sharedVerifiedChip: 'споделено · проверено',
      sharedVerifiedTooltip: 'Споделянето е проверено: кръстосаните сонди потвърждават, че всеки член вижда данните, записани от другите.',
      sharedDisputedChip: 'споделено · НЕ е проверено',
      sharedDisputedTooltip: 'Споделянето НЕ е проверено',
      sharedDisputedPair: '{observer} не вижда данните, записани от {writer}',
      sharedHint: 'Мрежов споделен ресурс, монтиран локално на един и същи път на всеки член — предпоставката за миграция на живо (декларативно).',
      sharedDanger: 'ОПАСНОСТ — TVirt ВЯРВА на този флаг: включите ли го, всеки член приема, че вижда СЪЩИТЕ байтове на този път. Върху папка, която НЕ е наистина споделен ресурс (NFS/CIFS/клъстерна файлова система), резултатът е повреда и загуба на данни при първата миграция или първия HA рестарт на друг възел. Включете го само ако пътят е споделен ресурс, монтиран идентично на всеки възел.',
      type: 'Тип',
      capacity: 'Капацитет',
      provisioned: 'Заделено',
      provisionedOvercommit: 'Потенциален ангажимент над капацитета: thin томовете могат да пораснат до {n} GiB.',
      phase: { ready: 'Готово', degraded: 'Деградирало', error: 'Грешка' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Конфигурация',
      tabCapacity: 'Капацитет и състояние',
      cardIdentity: 'Идентичност',
      cardPlacement: 'Разположение',
      cardConnection: 'Връзка',
      usedReal: 'Реална заетост',
      capacityUnknown: 'Възелът още не е докладвал капацитета на този пул — тук числа не се измислят',
      overcommitHint: 'Ангажимент над капацитета: легитимен при thin пулове, дръжте под око реалната заетост',
      supportedContent: 'Поддържано съдържание',
      content: {
        disks: 'Дискове',
        catalogFiles: 'Каталожни файлове',
        backups: 'Бекъпи',
        appVolumes: 'Томове на приложения'
      },
      defaultDiskFormat: 'Дисков формат по подразбиране',
      reserveGiB: 'Запазено свободно пространство (GiB)',
      available: 'Налично',
      diskCount: 'Дискове',
      filesystem: 'Файлова система',
      observedAt: 'Наблюдавано на',
      lostAtRow: 'Декларирано изгубено на',
      sharedProbeRow: 'Проверка на споделянето',
      sharedProbeNodes: 'Сондирани възли',
      reachableFrom: 'Декларирана достъпност',
      reachableFromHint: 'Възлите, от които това хранилище трябва да е достъпно. ВМ с дискове, ISO или метаданни тук нито стартира, нито мигрира на възел извън този списък. Всички членове са предварително избрани: стеснете както желаете. Възел, който влезе в клъстера по-късно, остава извън, докато не го добавите тук.',
      reachableFromNone: 'не е декларирана',
      reachableFromTags: 'Достъпност по тагове',
      reachableFromTagsHint: 'Селектор таг=стойност (записи, разделени със запетая, в AND): всеки член, който носи тези тагове, е деклариран достъпен — динамично: тагването на възел го включва.',
      reachableFromTagsInvalid: 'Невалиден формат — използвайте таг=стойност, разделени със запетая',
      reachableResolved: 'Разрешени възли: {nodes}',
      reachableDeclaredNotSeen: 'деклариран, но не видян от сондата за споделяне на: {nodes}',
      reachableSeenNotDeclared: 'видян, но не деклариран (извън периметъра) на: {nodes}',
      cephCluster: 'Управляван Ceph клъстер',
      appGuardTitle: 'Хранилище в употреба от приложенията',
      appEphemeralGuard: 'това хранилище е клъстерният ефемерен пул на приложенията — първо го сменете от страницата Приложения, после го изтрийте.',
      appInUseGuard: 'тук живеят root-ове/томове на приложения: {apps} — преместете ги или ги изтрийте първо.',
      releaseRequiredTitle: "Да се изтрие ли '{name}' и да се освободят образите му?",
      releaseRequiredBatchTitle: 'Да се изтрият ли избраните storage и да се освободят образите им?',
      releaseRequiredBody: 'Освобождаването на образите не изтрива НИТО един байт: дерегистрацията оставя namespace на диска, образите просто престават да бъдат материализирани и всяка референция на scope оцелява като claim — регистрирайте pool отново и те се осиновяват пак.',
      releaseConfirm: 'Изтрий и освободи образите'
    },
    lost: {
      chip: 'Изгубено',
      action: 'Декларирай като изгубено',
      confirmTitle: 'Деклариране на хранилището като изгубено',
      confirmBody: 'Атестация на оператора на негов деклариран риск: всяка задача в опашка или в изпълнение върху това хранилище или обектите му ЩЕ СЕ ПРОВАЛИ, изтриванията стават само по регистър (никаква работа по файловата система), а новата физическа работа се отказва. Байтовете никога не се докосват — ако томът се върне към живот, регистрирайте го отново и изпълнете сканиране, за да приемете отново всичко.',
      confirmSubmit: 'Декларирай като изгубено',
      error: 'Атестацията беше отказана'
    },
    findings: {
      action: 'Намерени обекти',
      title: 'Намерени обекти',
      empty: 'Няма намерени обекти в именното пространство на хранилището',
      loadError: 'Неуспешно зареждане на намерените обекти',
      actionError: 'Решението беше отказано',
      colKind: 'Тип',
      colObject: 'Обект',
      colConflict: 'Конфликт',
      namespaceNotice:
        'Тази директория вече е била инициализирана от друго хранилище: печатът за идентичност е презаписан с този на текущото хранилище. Съдържанието НЕ е променяно — прегледайте намерените обекти по-долу, импортирайте нужните и след това отхвърлете това известие.',
      kind: {
        disk: 'Диск',
        catalogFile: 'Каталожен файл',
        vmMetadata: 'ВМ метаданни',
        namespace: 'Именно пространство',
        foreign: 'Чужд',
        volumeGroup: 'Група томове'
      },
      vgAdopt: {
        action: 'Осинови групата томове',
        title: 'Осинови групата томове',
        intro:
          'Това устройство вече носи група томове с име на TVirt, но нейният печат не назовава нито един регистриран тук storage. Може да е това, което предишен storage на ТОЗИ клъстер е оставил на LUN — или това, което ДРУГ TVirt клъстер е оставил на LUN, сменил стопанина си: оттук двата случая изглеждат еднакво и затова никой не решава вместо вас.',
        irreversible: 'Погледнете устройството, печата и името, преди да продължите: осиновяването не се отменя.',
        device: 'Устройство',
        seal: 'Печат',
        sealNone: 'няма (без етикет tvirt.storageId)',
        renameTo: 'Ще бъде преименувана на',
        renameNone: 'Без преименуване: името вече е това, което този storage извежда',
        volumesNote:
          'Съдържащите се томове НЕ се осиновяват с този жест: следващото сканиране ги предлага един по един, като обикновени намерени обекти.'
      },
      conflictChip: 'ID вече съществува',
      dismissedChip: 'Игнориран',
      adopt: 'Приеми',
      adoptFileTitle: 'Импортиране в каталог',
      adoptFileHint: 'Файловете съществуват само вътре в каталозите: изберете каталог местоназначение за намерения файл.',
      purge: 'Изтрий от диска',
      dismiss: 'Игнорирай',
      purgeConfirmTitle: 'Изтриване от диска',
      purgeConfirmBody: 'Намерените байтове на {id} ще бъдат премахнати от хранилището. Операцията е необратима.',
      taskStarted: 'Стартирано — продължава като фонова задача',
      scan: 'Сканирай хранилището',
      scanStarted: 'Сканирането започна…',
      scanDone: 'Сканирането завърши — намерените обекти са обновени'
    },
    reinit: {
      action: 'Опитай отново инициализацията'
    },
    wizard: {
      addButton: 'Добави',
      title: 'Добавяне на хранилище',
      back: 'Назад',
      continue: 'Продължи',
      selectHint: 'Изберете протокол, за да видите как TVirt го използва.',
      roadmap: 'Пътна карта',
      server: 'Сървър',
      export: 'Експортиран път',
      share: 'Споделена папка',
      username: 'Потребителско име',
      password: 'Парола',
      passwordHint: 'Само за запис: използва се за монтирането, никога повече не се показва.',
      credential: 'Идентификационни данни',
      credentialManual: 'Въведи ръчно',
      credentialHint: 'Запис от хранилището за ключове от тип потребителско име и парола — алтернативата на въвеждането им тук.',
      credentialEmpty: 'Няма идентификационни данни от тип потребителско име и парола в хранилището за ключове — създайте ги в Система → Идентификационни данни или въведете акаунта по-долу.',
      options: 'Опции за монтиране',
      optionsHint: 'Разделени със запетая, подават се на mount -o както са.',
      portal: 'Портал',
      portalHint: 'хост[:порт] — портът по подразбиране е 3260.',
      target: 'Target IQN',
      targetHint: 'Името на iSCSI таргета, започва с iqn.',
      lun: 'LUN',
      wholeLunRow: 'На дисковете: този storage назовава само target-а',
      wholeLunHint: 'Този storage назовава само target-а: неговите LUN-ове стават дискове един по един (Създай диск → приеми цял LUN), на target-а нищо не се записва.',
      lunHint: 'Номер на LUN на таргета — 0 при съмнение.',
      chapCredential: 'Идентификационни данни (CHAP)',
      chapCredentialHint: 'Запис от хранилището за ключове от тип CHAP (iSCSI), използван при login — секретът никога не пътува с хранилището.',
      chapNone: 'Без автентикация',
      chapEmpty: 'Няма идентификационни данни от тип CHAP (iSCSI) в хранилището за ключове — създайте ги в Система → Идентификационни данни. Без тях login-ът остава неавтентикиран.',
      address: 'Адрес',
      addressHint: 'Хост или IP на NVMe/TCP таргета (traddr).',
      port: 'Порт',
      portHint: 'TCP порт на таргета — 4420, ако е оставено празно.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN на подсистемата на таргета, започва с nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID вътре в подсистемата — 1 при съмнение.',
      dhchapCredential: 'Идентификационни данни (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Запис от хранилището за ключове от тип DH-HMAC-CHAP (NVMe), използван при свързването — секретът никога не пътува с хранилището.',
      dhchapNone: 'Без автентикация',
      dhchapEmpty: 'Няма идентификационни данни от тип DH-HMAC-CHAP (NVMe) в хранилището за ключове — създайте ги в Система → Идентификационни данни. Без тях връзката остава неавтентикирана.',
      monitors: 'Монитори',
      monitorsHint: 'Крайни точки на Ceph мониторите, хост[:порт], разделени със запетая или на нов ред — порт по подразбиране 6789.',
      pool: 'Пул',
      poolHint: 'RBD пулът за консумиране — по един RBD образ на диск.',
      fs: 'Файлова система',
      fsHint: 'Името на CephFS файловата система (mds_namespace при монтиране).',
      fsPath: 'Път вътре във файловата система',
      fsPathHint: 'Абсолютен път вътре във файловата система, който хранилището монтира — / при съмнение.',
      cephxCredential: 'Идентификационни данни (cephx)',
      cephxCredentialHint: 'Запис от хранилището за ключове от тип cephx: потребителско име = име на клиента (client.…), секрет = ключът base64. Задължително.',
      cephxNone: 'Няма cephx идентификационни данни в хранилището за ключове — създайте едни (тип: cephx) в Система → Идентификационни данни или оставете управляван Ceph клъстер да ги изкове с „Предложи като хранилище“.',
      sharedByNature: 'Мрежовите хранилища са споделени по природа: всеки член ги монтира на един и същи път, управляван от TVirt.',
      error: 'Хранилището беше отказано',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Друго',
        legacy: 'Legacy'
      },
      legacyHint: 'Поддържани напълно — просто не бихме ги избрали за нова инсталация.',
      proto: {
        dir: {
          name: 'Локална папка',
          desc: 'Директория на възела: просто и бързо. ЛОКАЛНА е за един възел, освен ако пътят не е наистина споделен ресурс — маркирането ѝ като споделена, когато не е, струва данни.',
          usage: 'TVirt пази тук дискове на ВМ, ISO/дискови образи и шаблони.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS експорт, монтиран от клъстера — споделен по природа.',
          usage: 'Приютява дискове на ВМ, ISO/дискови образи и шаблони.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba споделена папка, монтирана от клъстера — споделена по природа.',
          usage: 'Приютява дискове на ВМ, ISO/дискови образи и шаблони.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Отдалечена файлова система през SSH — без нужда от NAS експорт.',
          usage: 'В пътната карта.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Блокови LUN през IP със споделен LVM отгоре.',
          usage: 'Само дискове — по един thin том на диск; не приютява ISO образи, нито шаблони.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Разпределени блокови устройства върху Ceph клъстер.',
          usage: 'Само дискове — по един RBD образ на диск, отварян нативно от QEMU; не приютява ISO образи.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Разпределената файлова система на Ceph, монтирана от ядрото на клъстера — споделена по природа.',
          usage: 'Приютява дискове на ВМ, ISO/дискови образи и шаблони — семейството dir върху Ceph файлова система (cephx идентификационни данни задължителни).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN върху FibreChannel фабрика — класическата FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Същият SCSI върху FibreChannel, с FC кадрите капсулирани в Ethernet.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (цели LUN-ове)',
          desc: 'iSCSI target-ът като носител на цели LUN-ове: всеки диск Е LUN, подаден суров на госта — без LVM по средата.',
          usage: 'Само дискове — по един цял LUN на диск, приет както е; SAN домът на дисковете със споделен запис.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (цели namespace-ове)',
          desc: 'NVMe подсистемата като носител на цели namespace-ове: всеки диск Е namespace, подаден суров на госта.',
          usage: 'Само дискове — по един цял namespace на диск, приет както е; споделен запис да, SCSI persistent reservations не.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Отдалечен NVMe — никакъв SCSI по пътя — върху обикновен TCP, със споделен LVM отгоре.',
          usage: 'Само дискове — по един thin том на диск; не приютява ISO образи, нито шаблони.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Отдалечен NVMe върху FibreChannel фабрика.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe върху FibreChannel фабриката, която FCoE пренася вътре в Ethernet — слоевете FCoE и NVMe/FC един върху друг.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI с пътя на данните преместен върху RDMA — каквато и да е фабрика (InfiniBand, iWARP, RoCE). Изместен от NVMe/RDMA, още присъства в масивите и в ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Нативен SCSI върху RDMA, ерата преди iSER: InfiniBand (с discovery на фабриката) и RoCE — оцелява в дълголетните HPC хранилища.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Отдалечен NVMe върху която и да е RDMA фабрика — InfiniBand, iWARP, RoCE v1 и v2: една единствена конфигурация, възелът казва коя има.' },
        s3: { name: 'S3', desc: 'S3-съвместимо обектно хранилище — образи и резервни копия.' }
      }
    },
    catalogs: {
      title: 'Каталози',
      createTitle: 'Създай каталог',
      editTitle: 'Редактиране на каталога',
      docTitle: 'Каталог',
      notFound: 'Този каталог не съществува (вече?)',
      scopeHint: 'Който чете този скоуп, вижда (и може да използва) всеки файл от каталога',
      files: 'Файлове',
      noFiles: 'Няма файлове',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT шабл.',
        vmTemplate: 'ВМ шабл.',
        ociImage: 'OCI',
        firmwareOvmf: 'Фърмуер'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'системен',
      systemTooltip: 'Системен каталог: приютява вградените обекти на платформата и не може да се променя'
    },
    catalogFiles: {
      catalog: 'Каталог',
      kindLabel: 'Тип',
      physicalSize: 'Физически размер',
      virtualSize: 'Виртуален размер',
      importTemplateAction: 'Импортирай като VM Template',
      importTemplateLegacy: 'Няма деклариран формат — използваем като seed за дискове, не може да се импортира',
      importTemplateTitle: 'Импортиране като VM Template',
      importTemplateSubmit: 'Импортирай',
      importTemplateError: 'Неуспешен импорт',
      importTemplateHint: 'Пакетът .tvtpl става VM Template: замразеният хардуер от манифеста плюс по един диск за всеки запис в архива, всеки проверен срещу своя checksum. NIC и CD/DVD носителите не са част от архива — добавете ги след импорта.',
      importTemplateQcow2Hint: 'Гол qcow2 става шаблон с ЕДИН диск и декларирания хардуер по подразбиране: профил linux, UEFI, 2 vCPU, 2048 MiB, зареждане от единствения му диск. Коригирайте при разгръщането.',
      importTemplateName: 'Име на шаблона',
      importTemplateNameHint: 'Празно = {name} (-import-<n>, ако е заето)',
      importTemplateStorage: 'Хранилище за дисковете',
      importTemplateMetadataStorage: 'Хранилище за метаданните',
      importTemplateMetadataHint: 'Блоково хранилище не приютява метаданните на ВМ (фърмуер, varstore) — изберете едно dir/nfs/cifs.',
      importTemplateStarted: 'Импортът започна — шаблонът се появява в раздела Шаблони при затварянето на задачата.',
      kind: {
        iso: 'ISO образ',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'ВМ шаблон',
        'oci-image': 'OCI образ',
        'firmware-ovmf': 'OVMF фърмуер'
      },
      title: {
        iso: 'ISO образи',
        'ct-rootfs': 'CT шаблони',
        'vm-template': 'ВМ шаблони',
        'oci-image': 'OCI образи',
        'firmware-ovmf': 'OVMF фърмуер'
      },
      createTitle: {
        iso: 'Добавяне на ISO образ',
        'ct-rootfs': 'Регистриране на CT шаблон',
        'vm-template': 'Добавяне на ВМ шаблон',
        'oci-image': 'Добавяне на OCI образ',
        'firmware-ovmf': 'Добавяне на OVMF фърмуер'
      },
      formatHint: 'Изведен от разширението на избрания файл — коригирайте го, ако е познал грешно',
      tarballHint: 'Rootfs tarball в стандартния LXC формат (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, или обикновен .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar или .tar.gz), например от docker save',
      uploadResumeHint: 'Качването е прекъснато — файлът чака качване: изпратете отново същия файл, за да продължите',
      moveTitle: 'Преместване на файла',
      moveHint: 'Две независими измерения: Каталогът премества връзката (същото id, нито един байт не се мести, обхватът става този на каталога местоназначение); Хранилището премества данните — всяко свързано копие го следва, отказва се, докато файлът е в употреба. Избрани заедно: първо каталогът, после хранилището.',
      moveCatalog: 'Каталог местоназначение',
      moveCatalogHint: 'Само връзката сменя дома си: VM, която е монтирала файла, трябва да вижда каталога местоназначение',
      keepCurrent: 'Без промяна',
      rehomed: 'Връзката е преместена в избрания каталог',
      copyAction: 'Копирай в каталог…',
      copyTitle: 'Копиране в каталог',
      copyLinkHint: 'Копието е нова връзка към същите данни — нищо не се дублира в хранилището.',
      copyCatalog: 'Каталог местоназначение',
      copyCatalogHint: 'Копирането е начинът, по който файл пътува между каталози',
      sameCatalog: 'Същият като на източника',
      sharedObjectHint: 'Данните на този файл се споделят от {count} свързани копия',
      deleteLastLink: 'Това е ПОСЛЕДНАТА връзка към това съдържание: ще бъдат изтрити и данните от хранилището.',
      deleteLinkOnly: 'Ще бъде премахната само тази връзка — данните остават, все още достижими от другите свързани копия ({count}).',
      noCatalog: 'Няма никакъв каталог — създайте един',
      inlineCatalogName: 'Име на каталога',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'вграден',
      embeddedStorage: 'Вграден в платформата',
      embeddedNoMove: 'Вграден файл на платформата: не живее на никое хранилище — клонирайте го вместо това',
      embeddedCopyHint: 'Клонирането материализира вградените байтове върху истинско хранилище: изберете хранилище и каталог местоназначение — копието е нормален файл',
      sourceEmbedded: 'Вграден в платформата',
      nodesRow: 'Наличност по възли',
      nodesSummary: '{present} от {total} възела го имат',
      nodePresent: 'наличен',
      nodeMissing: 'липсва',
      nodeUnknown: 'все още не е докладвано',
      nodesHint: 'Ресурсът живее на диска на всеки възел (пакет trantor-tvirt-assets): възел без него не може нито да дефинира VM с този firmware, нито да предоставя Guest Tools. Различните версии между възлите са нормални по време на поетапно обновяване.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Изтегли',
      downloadNotReady: 'Съдържанието още не е готово — изтеглянето изисква файл в състояние ready',
      downloadDenied: 'Вашата роля не включва catalog.download — изтеглянето на байтовете е отделно право от използването на файла',
      objectRow: 'Обект в хранилището',
      objectLinksRow: 'Свързани копия',
      declaredChecksum: 'Деклариран SHA-256',
      usedByRow: 'Използван от',
      usedByVms: 'ВМ',
      usedByDisks: 'Дискове',
      transferRow: 'Трансфер',
      storageLockHint: 'Променя се само с действието Премести'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Разгледай съдържанието',
      title: 'Съдържание на хранилището',
      hint: 'Преброяване само за четене на това, което живее в това хранилище — всеки обект се управлява от своя раздел.',
      empty: 'Няма регистрирани обекти в това хранилище',
      loadError: 'Неуспешно зареждане на съдържанието',
      colDetail: 'Детайл',
      manage: 'Управлявай в неговия раздел',
      kind: {
        disk: 'Диск',
        catalogFile: 'Каталожен файл',
        ociBlob: 'OCI блоб',
        checkpoint: 'Чекпойнт',
        vmMetadata: 'ВМ метаданни',
        appRoot: 'Root на приложение',
        appVolume: 'Том на приложение'
      }
    },
    inventory: {
      tabCatalogs: 'Каталози',
      storage: 'Хранилище',
      sizeGib: 'Размер (GiB)',
      format: 'Формат',
      size: 'Размер',
      sourceType: 'Източник',
      sourceFile: 'Качване на файл',
      sourceUrl: 'Изтегляне от URL',
      file: 'Файл',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Задължително: изтеглянето се проверява срещу този SHA-256',
      verifyChecksum: 'Проверявай checksum',
      checksumOffHint: 'Изтеглянето ще бъде прието без проверка — изчисленият SHA-256 все пак се записва',
      uploading: 'Качване…',
      move: {
        action: 'Премести',
        diskTitle: 'Преместване на диска',
        target: 'Хранилище местоназначение',
        diskHint: 'Дискът запазва идентичността си: байтовете пътуват към избраното хранилище. ВМ, която го използва, трябва да е изключена; при налични снапшоти iSCSI страната отказва преместването.',
        noTargets: 'Няма съвместимо хранилище местоназначение',
        submit: 'Премести',
        error: 'Преместването беше отказано'
      },
      clone: {
        action: 'Клонирай',
        title: 'Клониране на диска',
        name: 'Име на копието',
        storage: 'Хранилище местоназначение',
        sameStorage: 'Същото като на източника',
        linked: 'Свързан клонинг',
        linkedHint: 'Мигновен qcow2 оверлей, окачен на диска източник (само за qcow2 източници). По подразбиране се прави пълно копие.',
        linkedCrossHint: 'Свързаният клонинг остава на хранилището на източника: изберете „Същото като на източника“, за да го включите.',
        submit: 'Клонирай',
        error: 'Клонирането беше отказано'
      },
      copy: {
        action: 'Копирай',
        name: 'Име на копието',
        storage: 'Хранилище местоназначение',
        sameStorage: 'Същото като на източника',
        submit: 'Копирай',
        error: 'Копирането беше отказано'
      },
      taskStarted: 'Стартирано — продължава като фонова задача',
      cephObjects: 'Към детайлите на обекта в Ceph',
      phase: {
        ready: 'Готов',
        creating: 'В създаване',
        'awaiting-upload': 'Чака качване',
        downloading: 'В изтегляне',
        verifying: 'В проверка',
        deleting: 'В изтриване',
        error: 'Грешка',
        'in-use': 'В употреба'
      }
    }
  }
}
